import { Box, Typography } from '@mui/material';

interface AsideSectionHeaderProps {
    title: string;
    subtitle?: string;
}

export default function AsideSectionHeader({ title, subtitle }: AsideSectionHeaderProps) {
    return (
        <Box mb={ 3 }>
            <Typography variant="h6"
                fontSize="16px"
                fontWeight={ 500 }
            >
                { title }
            </Typography>
            { subtitle && (
                <Typography variant="body2"
                    color="text.secondary"
                >
                    { subtitle }
                </Typography>
            ) }
        </Box>
    );
}
